import { render } from "./camera-devices-operate-dialog.vue?vue&type=template&id=2a32672f&scoped=true&ts=true"
import script from "./camera-devices-operate-dialog.vue?vue&type=script&lang=ts"
export * from "./camera-devices-operate-dialog.vue?vue&type=script&lang=ts"

import "./camera-devices-operate-dialog.vue?vue&type=style&index=0&id=2a32672f&scoped=true&lang=less"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a32672f"]])

export default __exports__